import {
  IonButton,
  IonButtons,
  IonContent,
  IonFab,
  IonFabButton,
  IonHeader,
  IonIcon,
  IonPage,
  IonSearchbar,
  IonTitle,
  IonToolbar
} from '@ionic/react';
import { addOutline, searchOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { PackagesList } from '../../components/packagesList/PackagesList';
import { packageManagmentServices } from '../../services/packageManagmentServices';
import { useRequireAuth } from '../../utilities/authorization';
import { useHistory } from 'react-router';

const packageList: React.FC <{type: 'received' | 'sent'}> = ({type}) => {
  const history = useHistory();
  const [title, setTitle] = useState<string>();
  const [filter, setFilter] = useState('');
  const [scrollTop, setScrollTop] = useState(0);
  const [showSearchbar, setShowSearchBar] = useState(false);
  const [focusedCard, setFocusedCard] = useState<HTMLIonCardElement | null>(null);

  useEffect(()=>{
    setTitle(type === 'received' ? 'My packages' : 'Sent packages');
  });

  useRequireAuth();
  return (
    <IonPage>
      <IonHeader >
        <IonToolbar>
          <IonTitle>{title}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen scrollEvents={true}
        onIonScroll={(e) => {
          setScrollTop(e.detail.scrollTop);
        }} onIonScrollEnd={(e) => {
          // eslint-disable-next-line no-console
          if (scrollTop < 10){
            return;
          }
          // focusedCard?.querySelector('.anchor')!.scrollIntoView({behavior: 'smooth'});
        }
        }>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonButtons slot="primary">
              <IonButton onClick={()=> setShowSearchBar(true)} hidden={showSearchbar}>
                <IonIcon icon={searchOutline} />
              </IonButton>
            </IonButtons>
            <IonTitle size="large">{title}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonSearchbar onIonChange={(event) => setFilter(`${event.detail.value}`)} hidden={!showSearchbar}/>
        <PackagesList type={type} fetchPackages={type === 'received' ? packageManagmentServices.getReceivedPackages : packageManagmentServices.getSentPackages} setFocusedCard={(el: HTMLIonCardElement) => setFocusedCard(el) } filter={filter} />
        {type === 'sent' ? <IonFab horizontal="end" vertical="bottom" slot="fixed">
          <IonFabButton color="dark" onClick={() => history.push('/sent-packages/new-shipment')}>
            <IonIcon icon={addOutline}></IonIcon>
          </IonFabButton>
        </IonFab> : <></>
        }
      </IonContent>
    </IonPage>
  );
};

export { packageList as PackageList };
